import { Stack, Typography, useTheme } from '@mui/material';
import SelectableCard from 'components/SelectableCard/SelectableCard';
import IdPChip from 'components/shared/IdPChip';
import React from 'react';
import { IIdP } from 'types/api';
import { TOnClick } from 'types/props';

interface IConfigurationStatusCardProps {
	icon: React.ReactElement;
	title: string;
	footerContent?: React.ReactElement | null;
	onClick?: TOnClick;
	disabled?: boolean;
	idp?: IIdP;
	testIdTopic?: 'sso' | 'scim' | 'jit' | 'xaa';
}

const ConfigurationStatusCard: React.FC<IConfigurationStatusCardProps> = ({
	icon,
	idp = null,
	disabled = false,
	title,
	footerContent = null,
	onClick = undefined,
	testIdTopic = undefined
}) => {
	const {
		palette: {
			primary: { highlight: primaryHighlight }
		}
	} = useTheme();
	return (
		<SelectableCard
			disabled={disabled}
			onClick={onClick}
			data-testid="configuration-status-card"
			data-card-topic={testIdTopic}
			sx={{
				width: 286
			}}
		>
			<Stack direction="column" height={207} justifyContent="space-between">
				<Stack px={2} pt={2} flexGrow={1}>
					<Stack
						direction="row"
						alignItems="center"
						justifyContent="space-between"
					>
						<Stack
							width={52}
							height={52}
							borderRadius={1}
							justifyContent="center"
							alignItems="center"
							color="primary.main"
							sx={{ backgroundColor: primaryHighlight }}
						>
							{icon}
						</Stack>
						{idp && <IdPChip idp={idp} />}
					</Stack>
					<Typography variant="subtitle1" mt={2.5}>
						{title}
					</Typography>
				</Stack>
				<Stack
					alignItems="center"
					direction="row"
					px={2}
					bgcolor={primaryHighlight}
					justifyContent="space-between"
					height={45}
				>
					{footerContent}
				</Stack>
			</Stack>
		</SelectableCard>
	);
};

export default ConfigurationStatusCard;
